import { useCallback, useEffect, useRef, useState } from 'react';
/** Обратный отсчёт в секундах для кнопок с кулдауном (например, повторной отправки кода). */
export function useCountdown() {
    const [secondsLeft, setSecondsLeft] = useState(0);
    const timerRef = useRef(null);
    const clear = useCallback(() => {
        if (timerRef.current !== null) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
    }, []);
    const start = useCallback((seconds) => {
        clear();
        const initial = Math.max(0, Math.ceil(seconds));
        setSecondsLeft(initial);
        if (initial === 0)
            return;
        timerRef.current = setInterval(() => {
            setSecondsLeft((prev) => {
                if (prev <= 1) {
                    clear();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    }, [clear]);
    useEffect(() => clear, [clear]);
    return { secondsLeft, start };
}
